/* ODAVIA header: open desktop dropdowns on hover — original code */
(function(){
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
  document.querySelectorAll('.header__inline-menu details').forEach(function(d){
    var timer;
    var summary = d.querySelector('summary');
    d.addEventListener('mouseenter', function(){
      clearTimeout(timer);
      d.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });
    d.addEventListener('mouseleave', function(){
      timer = setTimeout(function(){
        d.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 120);
    });
    /* Mausklick auf einen Hauptmenüpunkt öffnet die Kategorie (Desktop, Maus).
       Tastatur (click ohne Zeiger, e.detail === 0) und Touch behalten Dawns Auf-/Zuklappen. */
    if (summary) {
      summary.addEventListener('click', function(e){
        if (e.detail === 0) return;
        if (summary.dataset.href && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          e.preventDefault();
          window.location.href = summary.dataset.href;
        }
      });
    }
  });
})();
